import { z } from 'zod/v4';

/** CiTypeDTO */
export const CITypeDTO = z.object({
  /** @format uuid */
  id: z.uuid(),
  /** Name */
  name: z.string(),
  /** Label */
  label: z.string().optional(),
  /** Color */
  color: z.string().optional(),
  /** Icon */
  icon: z.string().optional(),
  /** Icon Size */
  icon_size: z.number().optional(),
  /** Config Fetcher */
  config_fetcher: z.string().optional(),
  /** Script Executor */
  script_executor: z.string().optional(),
  /** Like Parent */
  like_parent: z.boolean().optional(),
  /** Support Chr */
  support_chr: z.boolean().optional(),
});
export type CIType = z.infer<typeof CITypeDTO>;

/** CiTypeExtendedDTO */
export const CITypeExtendedDTO = CITypeDTO.extend({
  extend: CITypeDTO,
});
export type CITypeExtended = z.infer<typeof CITypeExtendedDTO>;

/** CiTypeListItemDTO */
export const CITypeListItemDTO = CITypeDTO.extend({
  parent_id: z.uuid(),
});
export type CITypeListItem = z.infer<typeof CITypeListItemDTO>;

/** CiTypeTreeItemDTO (TreeType wrapper) */
// export const CITypeTreeItemDTO = TreeTypeDTO(CITypeDTO);
// export type CITypeTreeItem = z.infer<typeof CITypeTreeItemDTO>;

/** CiTypeCreateDTO = Omit<CiTypeDTO, 'id'> + extend_id? */
export const CITypeCreateDTO = CITypeDTO.omit({ id: true }).extend({
  extend_id: z.uuid().optional(),
});
export type CITypeCreate = z.infer<typeof CITypeCreateDTO>;

/** CiTypeCisCount */
export const CITypeCisCountDTO = z.object({
  id: z.uuid(),
  extend_id: z.uuid().optional(),
  ci_type_name: z.string().optional(),
  ci_count: z.number(),
  deleted_ci_count: z.number(),
  children: z
    .object({
      ci_count: z.number(),
      deleted_ci_count: z.number(),
    })
    .optional(),
});
export type CITypeCisCount = z.infer<typeof CITypeCisCountDTO>;

/** CiTypeUpdateDTO = Partial<CiTypeDTO> */
export const CITypeUpdateDTO = CITypeDTO.partial();
export type CITypeUpdate = z.infer<typeof CITypeUpdateDTO>;

/** CITMap type */
export type CITMap = Map<string, CIType>;